import { render } from "./CashRegistersHistory.vue?vue&type=template&id=97d5f190&scoped=true"
import script from "./CashRegistersHistory.vue?vue&type=script&lang=js"
export * from "./CashRegistersHistory.vue?vue&type=script&lang=js"

import "./CashRegistersHistory.vue?vue&type=style&index=0&id=97d5f190&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d5f190"]])

export default __exports__